const questions = [
  {
    id: 1,
    question: "I ___ visited Paris.",
    options: ["have", "has", "had"],
    answer: "have",
    concept: "present_perfect_have_has",
    skill: "auxiliary_have",
    explanation: "Use 'have' with I / you / we / they in the Present Perfect."
  },
  {
    id: 2,
    question: "Which sentence is correct?",
    options: [
      "She have finished her work.",
      "She has finished her work.",
      "She finished her work just."
    ],
    answer: "She has finished her work.",
    concept: "present_perfect_third_person",
    skill: "auxiliary_has",
    explanation: "Use 'has' with he / she / it in the Present Perfect."
  },
  {
    id: 3,
    question: "They have ___ sushi before.",
    options: ["eat", "eaten", "ate"],
    answer: "eaten",
    concept: "present_perfect_past_participle",
    skill: "past_participle",
    explanation: "The Present Perfect uses the past participle form of the verb."
  },
  {
    id: 4,
    question: "___ you ever traveled abroad?",
    options: ["Have", "Has", "Did"],
    answer: "Have",
    concept: "present_perfect_questions",
    skill: "auxiliary_have",
    explanation: "Use 'Have' to form questions in the Present Perfect."
  },
  {
    id: 5,
    question: "Which sentence shows something that has NOT happened yet?",
    options: [
      "He finished his homework yesterday.",
      "He hasn't done his homework yet.",
      "He is doing his homework now."
    ],
    answer: "He hasn't done his homework yet.",
    concept: "present_perfect_yet",
    skill: "negative_form",
    explanation: "Use 'yet' with the Present Perfect to talk about unfinished actions."
  }
];

export default questions;


